'use strict';
angular.module('resCenDigitalPreviewOtherDetailModule', []).controller('resCenDigitalPreviewOtherDetailCtrl', [
    '$scope',
    '$state',
    '$stateParams',
    '$q',
    '$filter',
    '$timeout',
    'trsHttpService',
    'resourceCenterService',
    'resCtrModalService',
    'modalDialog',
    'trsspliceString',
    'storageListenerService',
    'trsPrintService',
    'ueditorService',
    '$rootScope',
    'globleParamsSet',
    'stockApiService',
    function(
        $scope,
        $state,
        $stateParams,
        $q,
        $filter,
        $timeout,
        trsHttpService,
        resourceCenterService,
        resCtrModalService,
        modalDialog,
        trsspliceString,
        storageListenerService,
        trsPrintService,
        ueditorService,
        $rootScope,
        globleParamsSet,
        stockApiService,
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态函数开始
         * @return {[type]} [description] null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: '1',
                PAGESIZE: 12,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.params = {
                bc: $stateParams.bc,
                // pageUrl: '',
                pubTime: decodeURIComponent($stateParams.docpubtime),
                // mediaId: $stateParams.nodeid,
                typeid: 'zyzx',
                modelid: 'getBmDetail',
                serviceid: $stateParams.historystore ? 'history' : 'epaper', // $stateParams.serviceid
                siteName: '0',
                pageSize: 50,
                pageNum: 1,
            };
            $scope.status = {
                currModule: 'szb',
                batchOperateBtn: {
                    hoverStatus: '',
                    clickStatus: '',
                },
                iwoEdit: {
                    1: 'iwonews',
                    2: 'iwoatlas',
                },
                newspaperEdit: {
                    1: 'newspapertext',
                    2: 'newspaperpic',
                },
                websiteEdit: {
                    1: 'websitenews',
                    2: 'websiteatlas',
                },
                isShowDetail: false,
                docPubtime: $filter('date')($scope.params.pubTime, 'yyyyMMdd').toString(),
                docPubtimeCN: getDocPubTimeCn(),
                hasData: true,
                paperName: $stateParams.papername,
                downloadTime: '',
                isChangeTime: true, // 是否通过改变日期
                imgOverWidth: 1, // 图片宽、高度 缩放比例
                listOpen: 'processView', // 默认选中的属性信息
                attrDropdown: {
                    groupProcess: true, // 集团取签流程
                    groupEntityInfo: true, // 集团实体信息
                    authorInfo: true, // 作者信息
                    draftRelatedInfo: true, // 稿件关联信息
                    relevantDraft: true, // 相关稿件
                    groupReprint: true, // 集团转载
                    relatedHotwords: true, // 关联热点词
                    reprintMedia: true, // 转载媒体
                },
                preCtrl: 'enabled',
                nextCtrl: 'enabled',
                qjnews: $state.params.qjnews,
            };
            var splitTime = $scope.status.docPubtime.split('/');
            $scope.status.downloadTime = splitTime[0] + splitTime[1] + splitTime[2].split(' ')[0];
            $scope.data = {
                customConfig: {
                    singleDatePicker: true, // 是否是单选框
                    maxDate: globleParamsSet.dateFormat(new Date(), '-'),
                    minDate: stockApiService.historyMinDate,
                },
                items: [],
                space: '',
                headers: [],
                selectedArray: [],
                operFlags: [],
                detail: '',
                currItem: '',
                currIndex: '',
                pdfPath: '',
                dropDown: {
                    banciList: [],
                    selectedBanmian: {},
                },
                keywordsArray: [], // 关键词数组
                tagArray: [], // 标签信息
                tenantInfo: '', // 租户信息
                groupProcess: {
                    // 集团取签流程
                    medias: [], // 媒体列表
                    operators: [
                        {
                            // 操作人
                            name: '取稿人',
                            value: 'takeDraft',
                        },
                        {
                            name: '签发人',
                            value: 'issue',
                        },
                        {
                            name: '见报人',
                            value: 'appearNews',
                        },
                        {
                            name: '撤稿人',
                            value: 'withdraw',
                        },
                    ],
                    process: [], // 取签流程
                    selectedMedia: '', // 选中的产品
                },
                authorInfo: {
                    // 作者信息
                    authorList: [
                        {
                            // 作者信息列表
                            COMPANY: '浙报集团',
                            DEPT: 'TRS',
                            USERNAME: '何志恺特殊小号部队1号',
                        },
                    ],
                },
                draftRelatedInfo: {
                    // 稿件关联信息
                    relatedInfo: [
                        {
                            // 关联信息分类
                            name: '关联领导人',
                            value: '',
                        },
                        {
                            name: '关联机构',
                            value: '1',
                        },
                        {
                            name: '关联地域',
                            value: '2',
                        },
                    ],
                    selectedRelatedInfo: '', // 选中的关联信息分类
                    relatedLeaders: [], // 关联领导人
                    relatedOrganizations: [], // 关联机构
                    relatedAreas: [], // 关联地域
                },
                relevantDraft: {
                    // 相关稿件
                    page: {
                        // 相关稿件分页
                        CURRPAGE: 1,
                        PAGESIZE: 10,
                    },
                    draftList: [], // 相关稿件列表
                },
                groupReprint: {
                    // 集团转载
                    reprintList: [],
                },
                relatedHotwords: {
                    // 关联热点词
                    hotwordsList: [],
                },
            };
            $scope.basicParams = {
                channelName: $scope.status.currModule,
                mediaId: $stateParams.nodeid,
            };
            // 初始化canvas
            initCanvas();
            // 监听日期变化
            listenDate();
            // 查询当前报纸是否有上一期和下一期
            findOtherTermsPubtime();
        }

        /**
         * [getDocPubTimeCn description] 获取中文日期
         * @return {[type]} [description]
         */
        function getDocPubTimeCn() {
            var dateCn = '';
            var day;
            var date = new Date(Date.parse(unescape($state.params.docpubtime)));
            dateCn += $filter('date')(date, 'yyyy年MM月dd日 ');
            day = date.getDay();
            switch (day) {
                case 1:
                    day = '星期一';
                    break;
                case 2:
                    day = '星期二';
                    break;
                case 3:
                    day = '星期三';
                    break;
                case 4:
                    day = '星期四';
                    break;
                case 5:
                    day = '星期五';
                    break;
                case 6:
                    day = '星期六';
                    break;
                case 0:
                    day = '星期日';
                    break;
            }
            return dateCn + day;
        }

        /**
         * [initStatus description]初始化请求数据函数开始
         * @return {[type]} [description] null
         */
        function initData() {
            headPortrait();
            requestBanciDropDown(unescape($stateParams.docpubtime)).then(function(data) {
                // $scope.params.pageUrl = data.content[0].IR_PAGEURL;
                // $scope.params.bc = data.content[0].BC;
                $scope.params.siteName = data.content[0].IR_SITENAME;
                $scope.data.imgUrl = data.content[0].IR_JPPATH;
                $scope.data.banmianName = data.content[0].BM;
                requestData();
            });
        }

        /**
         * [requestData description]请求数据函数开始
         * @return {[type]} [description] null
         */
        function requestData() {
            // $scope.params.pubTime = $filter('date')($scope.params.pubTime, 'yyyyMMdd').toString();
            $scope.params.pubTime = unescape($scope.params.pubTime).split(' ')[0].replace(/\//g, '');
            let params = angular.copy($scope.params);
            if ($stateParams.historystore) {
                params.mediaId = 'szbhistory542';
                params.docpubtime = params.pubTime;
            }
            let requestUrl = trsHttpService.getBigDataRootUrl();
            $scope.loadingPromise = trsHttpService.httpServer(requestUrl, params, 'post').then(function(data) {
                $scope.data.selectedArray = [];
                $scope.data.currIndex = '';
                $scope.data.items = data.content;
                // $scope.data.imgUrl = trueBanmianImg(data.content);
                $scope.data.banmianName = data.content[0].BM;
                $scope.basicParams.indexName = data.summary_info.indexName;
                $scope.status.isShowDetail = false;
                $scope.data.detail = '';
                $scope.data.currItem = '';
                var realWidth = data.content[0] ? data.content[0].IR_WIDTH : 0;
                var realHeight = data.content[0] ? data.content[0].IR_HEIGHT : 0;
                var isFromXML = data.content[0] && data.content[0].REMARKS && data.content[0].REMARKS === 'xml';
                var aspectRatio = realWidth / realHeight;
                var height = 300 / aspectRatio;
                data.content.forEach((item, index) => {
                    const readList = item.ZB.split(',');
                    if (readList.length === 4) {
                        const setList = [readList[0], readList[1], readList[2], readList[1], readList[2], readList[3], readList[0], readList[3]];
                        data.content[index].ZB = setList.join(',');
                    }
                    data.content[index].ZB = CoordMax(item.ZB, 300, height, realWidth, realHeight, isFromXML);
                    data.content[index].BMZB = CoordMax(item.BMZB, 300, height, realWidth, realHeight, isFromXML);
                });
                $('<img/>')
                    .attr('src', $scope.data.imgUrl)
                    .load(function() {
                        $('.left_Img').css({ width: 300 });
                        $('#Img_a_image').css({ width: 300, height: height });
                        $('#Img_a').css({ width: 300, height: height });
                        $('#Img_a_canvas').css({ width: 300, height: height });
                        $('#Img_a_canvas').attr({ width: 300, height: height });
                        init_area(realWidth, realHeight, isFromXML);
                    });
                initOperFlag();
            });
        }

        /**
         * [truePDF description]  找出PDF
         * @param   {[type]}  list  [list description]
         * @return  {[type]}        [return description]
         */
        function truePDF(list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].IR_PDFPATH) {
                    return list[i].IR_PDFPATH;
                }
            }
            return false;
        }

        /**
         * [requestBanciDropDown description] 请求版次下拉框
         * @param   {[type]}  date  [date description]
         * @return  {[type]}        [return description]
         */
        function requestBanciDropDown(date) {
            var defer = $q.defer();
            var banciParams = {
                serviceid: $scope.params.serviceid,
                modelid: 'getBmMenu',
                typeId: 'zyzx',
                docpubtime: date,
                siteName: $scope.status.paperName,
            };

            // 新疆日报历史稿库
            if ($scope.params.serviceid === 'history') {
                banciParams.modelid = 'findBmMenu';
                banciParams.mediaId = 'szbhistory542';
                banciParams.docpubtime = date.replace(/\/|\s.*$/g, '');
            }

            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), banciParams, 'post').then(function(data) {
                if (data.result === 'fail') {
                    $scope.status.hasData = false;
                    return;
                }
                var banciList = data.content,
                    index = 0;
                $scope.data.pdfPath = truePDF(data.content);
                angular.forEach(banciList, function(value, key) {
                    value.name = value.BC + '： ' + value.BM;
                    if (value.BC == $scope.params.bc) {
                        index = key;
                    }
                });
                $scope.data.dropDown.banciList = banciList;
                $scope.data.dropDown.selectedBanmian = banciList[index];
                // 自动将滚动条移到顶部
                $('trs-single-select').one('click', function() {
                    $timeout(function() {
                        $('.dropdown-menu')
                            .eq(0)
                            .scrollTop(0);
                    });
                });
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [openUrl description] 打开链接
         * @param   {[type]}  url  [url description]
         * @return  {[type]}       [return description]
         */
        $scope.openUrl = function(url) {
            if (!url) {
                return;
            }
            window.open(url);
        };

        /**
        * [downloadUrl description] 下载链接
        * @param   {[type]}  url  [url description]
        * @return  {[type]}       [return description]
        */
        $scope.downloadUrl = function(url) {
            window.location.href = url;
        };

        /**
        * [searchWithKeyword description] 选择版面
        * @param   {[type]}  banmian  [banmian description]
        * @return  {[type]}           [return description]
        */
        $scope.searchWithKeyword = function(banmian) {
            if ($scope.params.bc == banmian.BC) {
                return;
            }
            $scope.status.isChangeTime = false;
            $scope.params.bc = banmian.BC;
            $scope.data.imgUrl = banmian.IR_JPPATH;
            $scope.data.banmianName = banmian.BM;
            $scope.params.siteName = banmian.IR_SITENAME;
            requestData();
        };

        /**
         * [searchWidthList description] 点版面列表搜索
         * @param   {[type]}  banmian  [banmian description]
         * @return  {[type]}           [return description]
         */
        $scope.searchWidthList = function(banmian) {
            $scope.status.isChangeTime = false;
            if ($scope.params.bc == banmian.BC) {
                return;
            }
            $scope.params.bc = banmian.BC;
            $scope.params.siteName = banmian.IR_SITENAME;
            $scope.data.dropDown.selectedBanmian = banmian;
            $scope.data.imgUrl = banmian.IR_JPPATH;
            $scope.data.banmianName = banmian.BM;
            requestData();
        };

        /**
         * [listenDate description] 监听时间变化请求不同日期的报纸
         * @return  {[type]}  [return description]
         */
        function listenDate() {
            $scope.$watch('status.docPubtime', function(newValue, oldValue, scope) {
                if (newValue&&newValue != oldValue) {
                    $scope.status.isChangeTime = true;
                    var newDate = $filter('date')(newValue._d||newValue, 'yyyy/MM/dd').toString();
                    if (newDate.indexOf('00:00:00') < 0) {
                        newDate += ' 00:00:00';
                    }
                    $scope.params.pubTime = newDate;
                    var splitTime = newDate.split('/');
                    $scope.status.downloadTime = splitTime[0] + splitTime[1] + splitTime[2].split(' ')[0];
                    requestBanciDropDown(newDate).then(function(data) {
                        if (data.content[0].length < 1) {
                            $scope.status.hasData = false;
                            $scope.data.banmianName = '所选日期没有报纸';
                            return;
                        } else {
                            $scope.status.hasData = true;
                        }
                        $scope.data.imgUrl = data.content[0].IR_JPPATH;
                        $scope.data.banmianName = data.content[0].BM;
                        $scope.params.bc = data.content[0].BC;
                        $scope.params.siteName = data.content[0].IR_SITENAME;
                        requestData();
                    });
                }
            });
        }

        /**
         * [initOperFlag description] 初始化取签见撤重
         * @return  {[type]}  [return description]
         */
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.items, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                    guids: docIds,
                };
                params = angular.extend(params, $scope.basicParams);
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
            $scope.data.selectedArray = [];
        }

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description]
         * @param  {[type]} flagIndex [description]
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) {
            var temp = queryItemBYGUID(guid);
            if (!!temp) {
                return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
            } else {
                return false;
            }
        };

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description]
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].GUID) {
                    return $scope.data.operFlags[i];
                }
            }
        }
        // 取签见撤重 点击弹出

        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick) {
            var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
            resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
        };

        /**
         * [selectAll description] 全选
         * @return  {[type]}  [return description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description] 单选
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [openTakeDraftModal description]取稿
         * @return {[type]} [description]
         */
        $scope.openTakeDraftModal = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'fetch',
                guid: $scope.status.isShowDetail
                    ? $scope.data.currItem.ZB_GUID
                    : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
            };

            params = angular.extend(params, $scope.basicParams);
            var modalInstance = resCtrModalService.fullTakeDraft(params, true);
            modalInstance.result.then(
                function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        initOperFlag();
                    });
                },
                function() {
                    initOperFlag();
                }
            );
        };

        /**
         * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }


        /**
         * [CreationAxis description] 加入创作轴
         * @return  {[type]}  [return description]
         */
        $scope.CreationAxis = function() {
            var params = angular.copy($scope.basicParams);
            params.guid = $scope.status.isShowDetail
                ? $scope.data.currItem.ZB_GUID
                : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ',');
            resourceCenterService.setBigDataCreation(params).then(function(data) {
                modalDialog.alertType('该稿件已成功加入创作轴!', '', 'success', false);
                $scope.data.selectedArray = [];
            });
        };

        /**
         * [printbtn description] 打印
         * @return  {[type]}  [return description]
         */
        $scope.printbtn = function() {
            var params = {
                serviceid: $scope.status.currModule,
                modelid: 'detailData',
                guid: $scope.status.isShowDetail
                    ? $scope.data.currItem.ZB_GUID
                    : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                channelName: $scope.basicParams.channelName,
                typeid: 'zyzx',
                indexName: $scope.basicParams.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                trsPrintService.trsPrintBigData(data);
            });
        };
        // 预留
        $scope.openReserveDraftModal = function() {
            var selectedArray = $scope.status.isShowDetail ? [$scope.data.currItem] : $scope.data.selectedArray;
            var resCtrModalServiceModal = resCtrModalService.reserveDraft(selectedArray);
            resCtrModalServiceModal.result.then(function(result) {
                delete result.items;
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'delay',
                    guid: $scope.status.isShowDetail
                        ? $scope.data.currItem.ZB_GUID
                        : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                };
                params = angular.extend(params, $scope.basicParams);
                params = angular.extend(params, result);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        modalDialog.alertType('预留成功!', '', 'success', false, function() {
                            initOperFlag();
                            $scope.data.selectedArray = [];
                        });
                    },
                    function() {
                        initOperFlag();
                        $scope.data.selectedArray = [];
                    }
                );
            });
        };

        // 收藏
        $scope.collect = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'collect',
                guid: $scope.status.isShowDetail
                    ? $scope.data.currItem.ZB_GUID
                    : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
            };
            params = angular.extend(params, $scope.basicParams);
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, '');
            });
        };

        /**
         * [export description] 导出
         * @return  {[type]}  [return description]
         */
        $scope.export = function() {
            var params = {
                serviceid: 'mlf_exportword',
                methodname: 'exportBigDataDocs',
                GUIDS: $scope.status.isShowDetail
                    ? $scope.data.currItem.ZB_GUID
                    : trsspliceString.spliceString($scope.data.selectedArray, 'ZB_GUID', ','),
                CHANNELNAMES: $scope.basicParams.channelName,
                indexName: $scope.basicParams.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
            });
        };

        /** ********************************canvas开始**************************************/
        var canvascheck = document.createElement('canvas');
        var isVM = document.namespaces ? 1 : 0;
        var isJG = 0;
        var isCV = canvascheck.getContext ? 1 : 0;
        var jg = [];

        if (isVM) {
            if (document.namespaces['v'] == null) {
                // var stl = document.createStyleSheet();
                // stl.addRule("v\\:*", "behavior: url(#default#VML); antialias: true;");

                document.namespaces.add('v', 'urn:schemas-microsoft-com:vml');
            }
        }

        /**
         * [fadeCanvas description] 渐进动画
         * @param   {[type]}  id    [id description]
         * @param   {[type]}  opac  [opac description]
         * @return  {[type]}        [return description]
         */
        function fadeCanvas(id, opac) {
            var obj = document.getElementById(id);
            if (opac <= 100) {
                obj.style.opacity = opac / 100;
                opac += 10;
                window.setTimeout(fadeCanvas(id, opac), 10);
            }
        }

        /**
         * [CoordMax description] 处理传入点数据计算比例
         * @param   {[type]}  coord  [coord description] 传入的点位信息
         * @param   {[type]}  w      [w description] 采集时候的宽度
         * @param   {[type]}  h      [h description] 采集时候的高度
         * @param   {[type]}  realW  [realW description] 实际页面显示宽度
         * @param   {[type]}  realH  [realH description] 实际页面显示高度
         * @param   {[type]}  isFromXML  [realH description] 数据来源是否为XML，如果是，则返回的坐标点是数据是相对于图片宽高的百分比
         * @return  {[type]}         [return description]
         */
        function CoordMax(coord, w, h, realW, realH, isFromXML) {
            var arrays = coord.split(',');
            var cd;
            var newCoord = arrays
                .map(function(v, k) {
                    if (!isFromXML) {
                        if (k % 2 == 0) {
                            cd = (v / realW) * w;
                        } else {
                            cd = (v / realH) * h;
                        }
                    } else {
                        if (k % 2 == 0) {
                            cd = v / 100 * w;
                        } else {
                            cd = v / 100 * h;
                        }
                    }
                    return parseInt(cd);
                    
                }, this)
                .toString();
            return newCoord;
        }

        /**
         * [setAreaOver description] 鼠标移动进来的时候进行动画的绘制
         * @param   {[type]}  obj  [obj description] 传入hover对象
         * @param   {[type]}  id   [id description] 绘制canvas的id值（固定为：Img_a_canvas）
         * @param   {[type]}  b    [b description] 填充背景颜色
         * @param   {[type]}  c    [c description] 填充边框颜色
         * @param   {[type]}  o    [o description] 背景透明度
         * @param   {[type]}  n    [n description] 判断是否描边0不描  1描
         * @param   {[type]}  f    [f description] 判断显示渐变动画
         * @param   {[type]}  z    [z description]  控制jg不知道有啥用
         * @return  {[type]}       [return description]
         */
        function setAreaOver(obj, id, b, c, o, n, f, z) {
            var i,
                j,
                x,
                y,
                context,
                p = '',
                canvas = document.getElementById(id);
            var v = obj.coords.split(',');
            if (isVM) {
                if (obj.shape.toLowerCase() == 'rect') {
                    canvas.innerHTML =
                        '<v:rect strokeweight="1" filled="t" stroked="' +
                        (n < 1 ? 't' : 'f') +
                        '" strokecolor="#' +
                        b +
                        '" style="zoom:1;margin:0;padding:0;display:block;position:absolute;left:' +
                        parseInt(v[0]) +
                        'px;top:' +
                        parseInt(v[1]) +
                        'px;width:' +
                        parseInt(v[2] - v[0]) +
                        'px;height:' +
                        parseInt(v[3] - v[1]) +
                        'px;"><v:fill color="#' +
                        c +
                        '" opacity="' +
                        o +
                        '" /></v:rect>';
                } else if (obj.shape.toLowerCase() == 'circle') {
                    canvas.innerHTML =
                        '<v:oval strokeweight="1" filled="t" stroked="' +
                        (n < 1 ? 't' : 'f') +
                        '" strokecolor="#' +
                        b +
                        '" style="zoom:1;margin:0;padding:0;display:block;position:absolute;left:' +
                        parseInt(v[0] - v[2]) +
                        'px;top:' +
                        parseInt(v[1] - v[2]) +
                        'px;width:' +
                        parseInt(v[2]) * 2 +
                        'px;height:' +
                        parseInt(v[2]) * 2 +
                        'px;"><v:fill color="#' +
                        c +
                        '" opacity="' +
                        o +
                        '" /></v:oval>';
                } else {
                    for (j = 2; j < v.length; j += 2) {
                        p += parseInt(v[j]) + ',' + parseInt(v[j + 1]) + ',';
                    }
                    canvas.innerHTML =
                        '<v:shape strokeweight="1" filled="t" stroked="' +
                        (n < 1 ? 't' : 'f') +
                        '" strokecolor="#' +
                        b +
                        '" coordorigin="0,0" coordsize="' +
                        canvas.width +
                        ',' +
                        canvas.height +
                        '" path="m ' +
                        parseInt(v[0]) +
                        ',' +
                        parseInt(v[1]) +
                        ' l ' +
                        p +
                        ' x e" style="zoom:1;margin:0;padding:0;display:block;position:absolute;top:0px;left:0px;width:' +
                        canvas.width +
                        'px;height:' +
                        canvas.height +
                        'px;"><v:fill color="#' +
                        c +
                        '" opacity="' +
                        o +
                        '" /></v:shape>';
                }
            } else if (isCV) {
                if (f < 1) {
                    canvas.style.opacity = 0;
                }
                context = canvas.getContext('2d');
                context.beginPath();
                context.lineWidth = '1';
                if (obj.shape.toLowerCase() == 'rect') {
                    context.rect(0.5 + parseInt(v[0]), 0.5 + parseInt(v[1]), parseInt(v[2] - v[0]), parseInt(v[3] - v[1]));
                    context.closePath();
                } else if (obj.shape.toLowerCase() == 'circle') {
                    context.arc(0.5 + parseInt(v[0]), 0.5 + parseInt(v[1]), parseInt(v[2]), 0, (Math.PI / 180) * 360, false);
                } else {
                    context.moveTo(parseInt(v[0]), parseInt(v[1]));
                    for (j = 2; j < v.length; j += 2) {
                        context.lineTo(parseInt(v[j]), parseInt(v[j + 1]));
                    }
                    context.closePath();
                }
                context.fillStyle = 'rgba(' + c + ',' + o + ')';
                context.strokeStyle = 'rgba(' + b + ',0)'; // 边框线暂时为透明
                context.fill();
                if (n < 1) {
                    context.stroke();
                }
                if (f < 1) {
                    fadeCanvas(id, 0);
                }
            } else {
                jg[z].setColor('#' + c);
                if (obj.shape.toLowerCase() == 'rect') {
                    jg[z].fillRect(parseInt(v[0]), parseInt(v[1]), parseInt(v[2] - v[0]) + 1, parseInt(v[3] - v[1]) + 1);
                } else if (obj.shape.toLowerCase() == 'circle') {
                    jg[z].fillEllipse(parseInt(v[0] - v[2]), parseInt(v[1] - v[2]), parseInt(v[2]) * 2 + 1, parseInt(v[2]) * 2 + 1);
                } else {
                    x = new Array();
                    y = new Array();
                    i = 0;
                    for (j = 0; j < v.length; j += 2) {
                        x[i] = parseInt(v[j]);
                        y[i] = parseInt(v[j + 1]);
                        i++;
                    }
                    jg[z].fillPolygon(x, y);
                }
                jg[z].paint();
            }
        }

        /**
         * [setAreaOut description] 鼠标退出
         * @param   {[type]}  obj  [obj description] 移除对象
         * @param   {[type]}  id   [id description] canvas的id
         * @param   {[type]}  f    [f description] 判断是否渐变（但是没用。。）
         * @param   {[type]}  z    [z description] 判断jq不知道干啥
         * @return  {[type]}       [return description]
         */
        function setAreaOut(obj, id, f, z) {
            var canvas = document.getElementById(id);
            if (isVM) {
                canvas.innerHTML = '';
            } else if (isJG) {
                jg[z].clear();
            } else if (isCV) {
                var context = canvas.getContext('2d');
                context.clearRect(0, 0, canvas.width, canvas.height);
            }
        }

        /**
         * [findMax description] 找寻页面的最大x、y
         * @param   {[type]}  coord  [coord description]
         * @return  {[type]}         [return description]
         */
        function findMax(coord) {
            var arrays = coord.split(',');
            var cdw = 0;
            var cdh = 0;
            arrays.forEach(function(v, k) {
                if (k % 2 == 0) {
                    if (v >= cdw) {
                        cdw = v;
                    }
                } else {
                    if (v >= cdh) {
                        cdh = v;
                    }
                }
            });
            return [Number(cdw), Number(cdh)];
        }

        /**
         * [init_area description] 进行数据初始化处理
         * @param   {[type]}  realWidth   [realWidth description]
         * @param   {[type]}  realHeight  [realHeight description]
         * @param   {[type]}  isFromXML  [isFromXML 是否来自XML]
         * @return  {[type]}              [return description]
         */
        function init_area(realWidth, realHeight, isFromXML) {
            var canvans_width = $('#Img_a_canvas').attr('width');
            var canvans_height = $('#Img_a_canvas').attr('height');
            if (!realWidth || !realHeight || realWidth === '0' || realHeight === '0') {
                $('.forArchives')
                    .find('area')
                    .each(function() {
                        var setList = findMax($(this).attr('coords'));
                        if (setList[0] > realWidth) {
                            realWidth = setList[0];
                        }
                        if (setList[1] > realHeight) {
                            realHeight = setList[1];
                        }
                    });
            } else {
                realWidth = realWidth - 20;
                realHeight = realHeight - 20;
            }
            $('#js_tbody')
                .find('a')
                .each(function() {
                    // $(this).attr('coords', CoordMax($(this).attr('coords'), canvans_width, canvans_height, realWidth, realHeight, isFromXML));
                });
            $('.forArchives')
                .find('area')
                .each(function() {
                    var $this = $(this);
                    // $this.attr('coords', CoordMax($(this).attr('coords'), canvans_width, canvans_height, realWidth, realHeight, isFromXML)); // 转变坐标为map区域 坐标
                    var $x = -70;
                    var $y = -80;
                    $this
                        .mouseover(function(e) {
                            if ($('.mapDiv').length > 0) {
                                return;
                            }
                            // var name = $(this).attr("alt") == "无标题" ? '' : $(this).attr("alt");
                            var name = $(this).attr('alt');
                            var index_num = $(this).index();
                            var mapClass = name != '无标题' ? 'mapDiv' : 'mapDiv hide';
                            var dom = "<div class='" + mapClass + "'><span class='name'></span></div>";
                            $('.resouCen-digitalDetail').append(dom);
                            $('.name').text(name);
                            $('.mapDiv')
                                .css({
                                    top: e.pageY + $y + 'px',
                                    left: e.pageX + $x + 'px',
                                })
                                .show('fast');
                        })
                        .mouseout(function() {
                            $('.mapDiv').remove();
                        })
                        .mousemove(function(e) {
                            $('.mapDiv').css({
                                top: e.pageY + $y + 'px',
                                left: e.pageX + $x + 'px',
                            });
                        });
                });
        }

        /**
         * [initCanvas description] 初始化canvas
         * @return  {[type]}  [return description]
         */
        function initCanvas() {
            $('.forArchives').delegate('.newsPaper', 'mouseover mouseout', function(event) {
                if (event.type == 'mouseover') {
                    setAreaOver(this, 'Img_a_canvas', '39,84,128', '254,255,96', '0.4', 0, 0, 0);
                } else if (event.type == 'mouseout') {
                    setAreaOut(this, 'Img_a_canvas', 0, 0);
                }
            });
        }

        /** ********************************canvas结束**************************************/
        /**
         * [checkDetail description] 查看稿件详情
         * @param   {[type]}  item   [item description]
         * @param   {[type]}  index  [index description]
         * @return  {[type]}         [return description]
         */
        $scope.checkDetail = function(item, index) {
            // if ($state.params.historystore && item.ID === $scope.detailId) {
            //     return;
            // }
            // $scope.detailId = item.ID;
            if (!$state.params.historystore && $scope.data.currIndex === index) {
                return;
            }
            var len = $scope.data.items.length - 1;
            if (len === 0) {
                $scope.status.preCtrl = 'disabled';
                $scope.status.nextCtrl = 'disabled';
            } else if (len === 1) {
                if (index === 0) {
                    $scope.status.preCtrl = 'disabled';
                    $scope.status.nextCtrl = 'enabled';
                } else {
                    $scope.status.preCtrl = 'enabled';
                    $scope.status.nextCtrl = 'disabled';
                }
            } else {
                if (index === 0) {
                    $scope.status.preCtrl = 'disabled';
                    $scope.status.nextCtrl = 'enabled';
                } else if (index === len) {
                    $scope.status.preCtrl = 'enabled';
                    $scope.status.nextCtrl = 'disabled';
                } else {
                    $scope.status.preCtrl = 'enabled';
                    $scope.status.nextCtrl = 'enabled';
                }
            }
            for (let i = 0; i < $scope.data.items.length; i++) {
                if (i === index) {
                    $scope.data.items[index].isHover = 'hover';
                } else {
                    $scope.data.items[index].isHover = '';
                }
            }
            var params = {
                // serviceid: $scope.params.serviceid,
                serviceid: 'jtcpg',
                // modelid: 'epaperDetail',
                modelid: 'detailData',
                typeid: 'zyzx',
                guid: item.ZB_GUID_CHAR,
                indexName: item.indexName,
            };

            if ($stateParams.historystore) {
                params = Object.assign({}, params, {
                    indexName: $scope.basicParams.indexName,
                    guid: item.ZB_GUID
                });
            }

            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.detail = data.content[0];
                $scope.basicParams.indexName = data.summary_info.indexName;
                $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/\r\n/g, '<br/>');
                $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/\r/g, '<br/>');
                $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/\n/g, '<br/>');
                $scope.data.detail.CONTENT = dealContent($scope.data.detail.CONTENT);
                // $scope.data.detail.CONTENT = $scope.data.detail.CONTENT.replace(/<img/g, '<img style="max-width:512px;"');
                $scope.status.isShowDetail = true;
                $scope.data.currItem = data.content[0];
                $scope.data.currIndex = index;
                $scope.keywords = data.content[0].ZB_KEYWORDS5;
                $scope.data.keywordsArray = data.content[0].ZB_KEYWORDS5 === '' ? [] : data.content[0].ZB_KEYWORDS5.split(';');
                $scope.data.tagArray = !data.content[0].TAG ? [] : data.content[0].TAG.split('·');
                if (!!data.content[0].ENTITY_ORG) {
                    var org = data.content[0].ENTITY_ORG.split(';');
                    for (var i = 0; i < org.length; i++) {
                        $scope.data.draftRelatedInfo.relatedOrganizations.push({
                            name: org[i],
                            random: Math.ceil(Math.random() * 5),
                        });
                    }
                }
                if (!!data.content[0].ENTITY_PLACE) {
                    var entityPlace = data.content[0].ENTITY_PLACE.split(';');
                    for (var j = 0; j < entityPlace.length; j++) {
                        $scope.data.draftRelatedInfo.relatedAreas.push({
                            name: entityPlace[j],
                            random: Math.ceil(Math.random() * 5),
                        });
                    }
                }
                findReprintCounts();
                getRelatedHotwords();
                getTenantId().then(function() {
                    getRelatedLeaders();
                    getRelevantDraft();
                    getGroupReprint();
                });
            });
        };

        /**
         * [returnToList description] 返回稿件列表页
         * @return  {[type]}  [return description]
         */
        $scope.returnToList = function() {
            if (!$scope.status.isShowDetail) {
                return;
            }
            $scope.status.isShowDetail = false;
            $scope.data.detail = '';
        };

        /**
         * [jumpToDraft description] 上一篇/下一篇
         * @param   {[type]}  isNext  [isNext description]
         * @return  {[type]}          [return description]
         */
        $scope.jumpToDraft = function(isNext) {
            if (
                (!isNext && $scope.data.currIndex == 0) ||
                (isNext && $scope.data.currIndex == $scope.data.items.length - 1) ||
                !$scope.status.isShowDetail
            ) {
                return;
            }
            var index = isNext ? $scope.data.currIndex + 1 : $scope.data.currIndex - 1;
            var item = $scope.data.items[index];

            $scope.checkDetail(item, index);
        };

        /**
         * [jumpToBanmian description] 上一版/下一版
         * @param   {[type]}  isNext  [isNext description]
         * @return  {[type]}          [return description]
         */
        $scope.jumpToBanmian = function(isNext) {
            var originalIndex = $scope.data.dropDown.banciList.indexOf($scope.data.dropDown.selectedBanmian),
                index = isNext ? originalIndex + 1 : originalIndex - 1;
            if ((!isNext && originalIndex == 0) || (isNext && originalIndex == $scope.data.dropDown.banciList.length - 1)) {
                return;
            }
            $scope.data.dropDown.selectedBanmian = $scope.data.dropDown.banciList[index];
            $scope.params.bc = $scope.data.dropDown.banciList[index].BC;
            $scope.data.imgUrl = $scope.data.dropDown.banciList[index].IR_JPPATH;
            $scope.params.siteName = $scope.data.dropDown.banciList[index].IR_SITENAME;
            $scope.data.banmianName = $scope.data.dropDown.banciList[index].BM;
            requestData();
        };

        /**
         * [jumpToPhase description] 上一期/下一期
         * @param  {Boolean} isNext [description]
         * @return {[type]}         [description]
         */
        $scope.jumpToPhase = function(isNext) {
            var params = $state.params;
            if ($scope.status.hasNext && isNext) {
                params.pubTime = $scope.status.hasNext;
            } else if ($scope.status.hasPrev && !isNext) {
                params.pubTime = $scope.status.hasPrev;
            } else {
                return;
            }
            $state.go($state.current.name, params, { reload: true });
        };

        /**
         * [findOtherTermsPubtime description]
         * @return {[type]} [description]
         */
        function findOtherTermsPubtime() {
            var mydate = $filter('date')($scope.status.docPubtime, 'yyyy/MM/dd').toString();
            var params = {
                typeid: 'zyzx',
                serviceid: 'szb',
                modelid: 'findOtherTermsPubtime',
                docpubtime: mydate.indexOf('00:00:00') < 0 ? mydate + ' 00:00:00' : mydate,
                mediaId: $stateParams.nodeid,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.status.hasNext = data.content[0].aftTermTime;
                $scope.status.hasPrev = data.content[0].befTermTime;
            });
        }
        $scope.download = function() {
            window.open($scope.data.pdfPath);
        };

        /**
         * [dealContent description]处理详情内容的格式
         */
        function dealContent(content) {
            return ueditorService
                .replaceHtmlBlank(content)
                .replace(/(<(?:p|div)[^>]*>(?:<(?:span|b)[^>]*>)*)(?:&nbsp;| |　)*/gi, '$1\u3000\u3000')
                .replace(/(<br[^>]*>)(?:&nbsp;| |　)*/gi, '$1　　')
                .replace(/>　　</g, '><')
                .replace(/style="[^>]*"/g, '');
        }

        // 获取头像
        function headPortrait() {
            // detail
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }
        $rootScope.$on('updateHeadPortrait', function(event, data) {
            headPortrait();
        });

        /**
         * [findReprintCounts description] 获取转载量
         * @return {[type]} [description]
         */
        function findReprintCounts() {
            var params = {
                typeid: 'zyzx',
                serviceid: 'jtcpg',
                modelId: 'findReprintCounts',
                tags: $scope.data.detail.MD5TAG,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.reprintCounts = !!data.content[0] ? data.content[0][$scope.data.detail.MD5TAG] : '0';
            });
        }

        /**
         * [getRelatedHotwords description] 获取关联热点词
         * @return {[type]} [description]
         */
        function getRelatedHotwords() {
            var params = {
                serviceid: 'relevant',
                modelid: 'getRelevantKeywords',
                typeid: 'zyzx',
                keyword: $scope.keywords,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                if (angular.isObject(data)) {
                    var tempArray;
                    for (var i in data) {
                        tempArray = {};
                        tempArray.mainCloud = {
                            name: i,
                        };
                        tempArray.subCloud = [];
                        for (var j in data[i]) {
                            for (var k in data[i][j]) {
                                tempArray.subCloud.push({ name: k, value: data[i][j][k] });
                            }
                        }
                        $scope.data.relatedHotwords.hotwordsList.push(tempArray);
                    }
                }
            });
        }

        /**
         * [getTenantId description] 获取租户id
         * @return {[type]} [description]
         */
        function getTenantId() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodName: 'findTenantById',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.tenantInfo = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getRelatedLeaders description] 获取关联领导人
         * @return {[type]}    [description]
         */
        function getRelatedLeaders() {
            var params = {
                serviceid: 'relevant',
                modelid: 'getRelevantLeader',
                typeid: 'zyzx',
                tarentId: $scope.data.tenantInfo.TENANTID,
                names: $scope.data.detail.ENTITY_NAME,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.draftRelatedInfo.relatedLeaders = data;
            });
        }

        /**
         * [getRelevantDraft description] 获取关联稿件
         * @return {[type]}    [description]
         */
        function getRelevantDraft() {
            var params = {
                serviceid: 'relevant',
                modelid: 'getRelevantManuscript',
                typeid: 'zyzx',
                tarentId: $scope.data.tenantInfo.TENANTID,
                guid: $stateParams.guid,
                pageSize: $scope.data.relevantDraft.page.PAGESIZE,
                pageNum: $scope.data.relevantDraft.page.CURRPAGE,
                keywords: $scope.keywords,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.relevantDraft.page = {
                    CURRPAGE: data.pageNum,
                    ITEMCOUNT: data.totalNum,
                    PAGECOUNT: data.totalPageNum,
                    PAGESIZE: data.pageSize,
                };
                $scope.data.relevantDraft.draftList = data.content;
                // storageListenerService.appendPageTurningStorage(data.content, "guid,dataBaseName,mediaChar", "resourceDetail", "ZB_GUID,indexname,channel");
            });
        }

        /**
         * [relevantDraftPageChanged description] 关联稿件分页
         * @return {[type]} [description]
         */
        $scope.relevantDraftPageChanged = function() {
            getRelevantDraft();
        };

        /**
         * [getGroupReprint description] 获取集团转载
         * @return {[type]} [description]
         */
        function getGroupReprint() {
            var params = {
                serviceid: 'jtcpg',
                modelid: 'Analysis',
                typeid: 'zyzx',
                md5: $scope.data.detail.MD5TAG,
                // userId: "",
                // rentId: $scope.data.tenantInfo.TENANTID
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.groupReprint.reprintList = data.content;
            });
        }

        /**
         * [jumpToDetail description] 跳转到关联稿件
         * @param  {[type]} draftList [description]
         * @return {[type]}           [description]
         */
        $scope.jumpToDetail = function(draftList) {
            storageListenerService.relatedPageTurningStorage(
                $scope.data.relevantDraft.draftList,
                'guid,dataBaseName,mediaChar',
                'relatedDetail',
                'ZB_GUID,indexname,channel'
            );
            if (draftList.mediaChar == 'xhsg') {
                window.open($state.href('front.networksource.xinhua', { guid: draftList.guid, indexname: draftList.dataBaseName, relateddetail: 1 }));
            } else {
                window.open($state.href('resourcedetail', { guid: draftList.guid, indexname: draftList.dataBaseName, relateddetail: 1 }));
            }
        };

        /**
         * @description: 新闻标题hover联动效果
         * @param {type}
         * @return:
         */
        $scope.titleMouseOver = function(item, index) {
            $scope.data.items[index].isHover = 'hover';
        };
        $scope.titleMouseOut = function(item, index) {
            $scope.data.items[index].isHover = '';
        };
    },
]);
